import { useNavigate } from "react-router-dom";
import "./adminLogin.css"
import {
  PinInput,
  PinInputField,
  HStack,
  Text,
  Stack,
  Input,
  InputGroup,
  InputLeftAddon,
  Button,
  Flex, Spacer ,VStack,Container
} from "@chakra-ui/react";
import { PhoneIcon, AddIcon, WarningIcon } from '@chakra-ui/icons'
import { useEffect, useRef, useState } from "react";
import axios, { Axios } from "axios"
import { useToast } from '@chakra-ui/react'

import logo from "../../../img/LogoU.png"
import { CheckedPhoneNumber } from "../../../hook/checkedCountryNumber/checkedCountryNumber";


export default function AdminLogin(params) {

    const [isSending,setIsSending] = useState(false);
    const [inptValue,setinptValue] = useState("");
    const [loading,setloading] = useState(false);
    const [inpDisapled,setInpDisapled] = useState(false);
  
    const [pohoneNumber,setPohoneNumber] = useState("");
    const navigate = useNavigate()
    const toast = useToast({ position: 'top'})
    const focus = useRef(null)
  

   

  useEffect(()=>{
    
    if (isSending) {   
      setIsSending(true)
      setInpDisapled(true)
      setloading(true)  
      setinptValue("")
     
      axios.post('/checkPinCode/admin/api', {
          pinCode:inptValue
      })
      .then(function (response) {
        console.log(response);
        setIsSending(false)
        setInpDisapled(false)
        setloading(false)
        if (response.data.authorization) {
          navigate("/adminPage")
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsSending(false)
        setInpDisapled(false)
        setloading(false)
        toast({
          title: "Ошибка",
          description:error.response.data.message ,
            status:"error",
          duration: 2000,
          isClosable: true,
          
        })
      });
    }
  },[isSending])
  

  
  
    const handelPincode=(e)=>{
      setinptValue(e)
     //без проверяется если пин-код длина равна 4 тогда отправляется сервер
      if (e.length === 4) {
          console.log("send server");
          setIsSending(true)
          setInpDisapled(true)
       
      }
  
  }
  
  
  //Вот как мы отправляем номер телефона на сервер, чтобы позвонить нам
  const handleCall=()=>{
 
    if (pohoneNumber.length > 0) {
      setloading(true)
    setInpDisapled(true)
    axios.post('/calladmin/tel/api', {
      tel:pohoneNumber
    })
    .then(function (response) {
      console.log(response);
      setloading(false)
      setInpDisapled(false)
      
      toast({
        title: response.data.info,
        description: "пожалуйста подождите.",
       
        duration: 2000,
        isClosable: true,
        colorScheme:"#5E80E4"
      })
     
    })
    .catch(function (error) {
    
      console.log(error);
      setloading(false)
      setInpDisapled(false)
      toast({
        title: "Ошибка",
        description: error.response.data.message,
        
        duration: 2000,
        isClosable: true,
        status:"error"
      })
       
    });
        console.log("called");
    }else{
      toast({
        title: "ошибка",
        description: "вы не набрали свой номер телефона.",
        status:"error",
        duration: 2000,
        isClosable: true,
        colorScheme:"#5E80E4"
      })
    }
    
  }
            return(
                <div className="aouthCont">
                <div>
                  <img src={logo} alt="" />
                </div>
              <h1 style={{fontSize:"50px",color:"#5E80E4"}} className={"logoName"}>
                {/* <Stack spacing={3}>
                  <Text fontSize="6xl" as={"b"} color={"#5E7DE8"}>Упрости</Text>
                  <Stack spacing={3}>
                </Stack>
                </Stack> */}
                УПРОСТИ 
               
              </h1>
                <h2 style={{fontSize:"45px",color:"#5E80E4"}} className={"logoName"}> Администрация</h2>
                {/* <div className="countryImg">
                   <img src="https://img.icons8.com/color/256/armenia-circular.png" alt="" srcset="" />
                 </div> */}
        <div>
               <p style={{color:"#5E7DE8",marginBottom:"10%",justifyContent:"c"}} className="enterPhone">Введите ваш номер телефона</p>
                  <InputGroup  className={"phoneINP"}>
                    <InputLeftAddon children={"+"} color={"#5E7DE8"}  />
                    <Input
                     type="number"
                      placeholder="79000000000"
                    value={pohoneNumber}
                      borderColor={"#5E7DE8"}
                      onChange={(e)=> setPohoneNumber(e.target.value)}
                     
                    />
                  </InputGroup>
                  <p className="wrap" >
          После нажатия на кнопку вам поступит звонок. Отвечать на звонок не нужно
       
          </p>
              </div>
              <div>
                {loading?
              <Button
              isLoading
              colorScheme='#5E7DE8'
              backgroundColor={"#5E7DE8"}
              width={"270px"}
              className={"pinBTN"}
            >
              подождите
            </Button>
                :
                <Button onClick={handleCall} colorScheme="blue" background={"#5E7DE8"} width={"270px"} isDisabled={inpDisapled}   className={"pinBTN"} rightIcon={<PhoneIcon />}>получить звонок</Button>
                }
              </div>
              
              <div>
               
                  <PinInput type="alphanumeric"  color="#5E7DE8"  colorScheme='#5E7DE8' focusBorderColor={"#5E7DE8"} value={inptValue} onChange={(e)=>[ handelPincode(e)]} isDisabled={inpDisapled} variant="flushed" isRequired={true}>
                    <PinInputField  width={"60px"} ref={focus}  autoFocus={true} type="number"/>
                    <PinInputField  width={"60px"}  type="number"/>
                    <PinInputField  width={"60px"}  type="number"/>
                    <PinInputField  width={"60px"} type="number"/>
                  </PinInput>
               
              </div>
              <div>
               
                <Text fontSize='1xl' color={"#5E7DE8"} >Введите последние 4 цифры номера </Text>
                
                
              </div>
                
              
      </div>
            )
}